import NavigationLayout from "../../navigation/navigationLayout";
import FooterLayout from '../../footer/footerLayout';
import { Box, Stack, useTheme } from "@mui/material";
import DigitalServicesTabView from "./digitalServicesTabView";

const DigitalServicesLayout = () => {
    const theme = useTheme();

    return (
        <>
            <NavigationLayout />

            <Box 
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default,
                    pt: {xs: 12, md: 15, lg: 20},
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='start'
                    alignItems='center'
                    px='5%'
                >
                    <DigitalServicesTabView />
                </Stack>
            </Box>

            <FooterLayout />
        </>
    );
}

export default DigitalServicesLayout;